/**
 * voiceNote slice: 음성 노트 / STT 설정 관리
 * wehago-conference의 redux/modules/voiceNote + sttSetting 에서 리팩토링
 */
import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

export interface VoiceNoteState {
  isEnabled: boolean;
  language: string;
  // STT 마이크 권한을 부여받은 사용자 목록 (발언권과 유사)
  micGrantList: string[];
  isTranslationMode: boolean;
  /** 다른 참여자 중 STT를 활성화한 userId 집합 (CHANGE_SPEECH_BUTTON 커맨드로 갱신) */
  sttParticipants: Record<string, boolean>;
}

const initialState: VoiceNoteState = {
  isEnabled: false,
  language: 'ko',
  micGrantList: [],
  isTranslationMode: false,
  sttParticipants: {},
};

const voiceNoteSlice = createSlice({
  name: 'voiceNote',
  initialState,
  reducers: {
    setEnabled(state, action: PayloadAction<boolean>) {
      state.isEnabled = action.payload;
    },

    setLanguage(state, action: PayloadAction<string>) {
      state.language = action.payload;
    },

    setMicGrantList(state, action: PayloadAction<string[]>) {
      state.micGrantList = action.payload;
    },

    setTranslationMode(state, action: PayloadAction<boolean>) {
      state.isTranslationMode = action.payload;
    },

    /** 다른 참여자의 STT 활성 상태 갱신 (CHANGE_SPEECH_BUTTON) */
    setSttParticipant(state, action: PayloadAction<{ userId: string; enabled: boolean }>) {
      const { userId, enabled } = action.payload;
      if (enabled) {
        state.sttParticipants[userId] = true;
      } else {
        delete state.sttParticipants[userId];
      }
    },

    /** 참여자 퇴장 시 STT 추적 제거 */
    removeSttParticipant(state, action: PayloadAction<string>) {
      delete state.sttParticipants[action.payload];
    },

    reset() {
      return initialState;
    },
  },
});

export const voiceNoteActions = voiceNoteSlice.actions;
export default voiceNoteSlice.reducer;
